import React from "react";
import { Row, Col, Media, Fade } from "reactstrap";
import { mldInvest } from "../assets/constants/mld-invest";


const WorkFold = (props) => {
return(
    <div style={{backgroundColor:"white"}} className="w-100 work-fold-div">
        <div className="section-max-width">
        <Col xs={12} lg={12} className="text-center">
        <div className="info-block">
            <Fade bottom="bottom" distance="50px">
            <p className="work-title">
                {mldInvest.workFlow.title}
            </p>
            <p className="work-subtitle">
                {mldInvest.workFlow.subtitle}
            </p>
            </Fade>
        </div>
        </Col>
        <div className="work-fold invest-option" style={{ maxWidth: "100%" }}>
            {mldInvest.workFlow.content.map((item) => (
            <Col
                lg={3}
                sm={12}
                xs={12}
                md={12}
                className="d-flex flex-column work-col"
            >
                <Row className="align-items-center work-option-row">
                <Media src={item.imgSrc} alt="alt-asset" className="work-img" />
                <div className="d-flex flex-column align-items-center content ">
                    <p className="subtext">
                    {item.text}
                    </p>
                    <p className="text">
                    {item.subtext}
                    </p>
                </div>
                </Row>
            </Col>
            ))}
        </div>
        </div>
    </div>
 )
}

export default WorkFold;
